import { axiosInstance } from 'src/util/axios/instance.axios'
import { CourseDevelopmentChart, CourseHighlights } from '../model/my-team-elearning'

export async function getCourseDevelopment(startDate: string, endDate: string, orgLevelIds: string[]): Promise<CourseDevelopmentChart> {
  const { data } = await axiosInstance.request({
    url: `/my-team/elearning-progress/`,
    method: 'post',
    data: {
      startDate,
      endDate,
      orgLevelIds,
    },
  })

  return data
}

export async function getCourseHighlights(startDate: string, endDate: string, orgLevelIds: string[]): Promise<CourseHighlights[]> {
  const { data } = await axiosInstance.request({
    url: `/my-team/elearning-course-highlights/`,
    method: 'post',
    data: {
      startDate,
      endDate,
      orgLevelIds,
    },
  })
  
  return data
}